import { routeAction } from "./spa-app-actions.js";
import { defaultLogger } from "../helper/logger.js";
import { actions$, createEffect } from "mini-rx-store";
import { tap } from "rxjs/operators";
import { ofType } from "ts-action-operators";
//#region src/store/spa-app-effects.ts
var routeElement;
var setRouteElement = (param) => {
	routeElement = param;
};
var appRouteEffect = createEffect(actions$.pipe(ofType(routeAction), tap((action) => {
	if (!routeElement) defaultLogger.error("No route element set for appRouteEffect");
	else routeElement.dispatchEvent(new CustomEvent("route-event", {
		detail: { route: action.payload },
		bubbles: true,
		composed: true
	}));
})), { dispatch: false });
//#endregion
export { appRouteEffect, setRouteElement };
